import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "Icon / PlayCircle" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12ZM12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM10.916 8.37596C10.6859 8.22253 10.39 8.20823 10.1461 8.33874C9.90224 8.46926 9.75 8.7234 9.75 9V15C9.75 15.2766 9.90224 15.5307 10.1461 15.6613C10.39 15.7918 10.6859 15.7775 10.916 15.624L15.416 12.624C15.6247 12.4849 15.75 12.2508 15.75 12C15.75 11.7492 15.6247 11.5151 15.416 11.376L10.916 8.37596ZM13.6479 12L11.25 13.5986V10.4014L13.6479 12Z",
    fill: "#E31E33"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }